import { Outlet, useLocation } from "react-router-dom";

import { LoggedInHeader } from "components";
import { useCurrentUser } from "providers/CurrentUserProvider";

export default function LoggedInLayout() {
	const user = useCurrentUser();
	const location = useLocation();
	const isInBackoffice = Boolean(/backoffice/g.exec(location.pathname)?.length);

	return (
		<>
			{isInBackoffice ? (
				<LoggedInHeader baseUrl="/backoffice/" isExternalUser={false} />
			) : (
				user && <LoggedInHeader baseUrl="/" isExternalUser />
			)}
			<div className="h-[calc(100%-3.5rem)] sm:h-[calc(100%-4rem)] -mt-[1px]">
				<Outlet />
			</div>
		</>
	);
}
